export default class CheckSynchronization {
    constructor() {
        this.syncMessage = document.querySelector("[id=sync-message]");
        if (this.syncMessage) {
            this.numberOfRequest = 0;
            this.checkIfCMSIsSync();
        }
    }

    checkIfCMSIsSync() {
        fetch(this.syncMessage.dataset.checkSyncUrl, {
            credentials: "include",
        }).then((response) => {
            if (response.status === 204) {
                this.numberOfRequest += 1;

                if (this.numberOfRequest <= 10) {
                    setTimeout(this.checkIfCMSIsSync.bind(this), 2000);
                } else {
                    this.syncMessage.classList.remove("d-n");
                    this.syncMessage.classList.add("d-f");
                    document.getElementById("loader-bloc").classList.add("d-n");
                }
            } else if (response.status === 205) {
                window.location.reload(true);
            }
        }).catch((error) => {
            console.log(`There has been a problem with your fetch operation: ${error.message}`);
        });
    }
}